import React from "react";
import { motion } from "motion/react";
import "./styles.css";

const FloatingContainer = ({
  children,
  onClose,
  className = "",
  ...props 
}) => {
  return (
    <motion.div
      className={`floating-container ${className}`}
      {...props}
    >
      <div className="close-menu" onClick={onClose}>
        <div className="bar-1"></div>
        <div className="bar-2"></div>
      </div>
      <div className="column">
        {children}
      </div>
    </motion.div>
  );
};

export default FloatingContainer;
